// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kuWz","content":"styles_content__2pHVt","row":"styles_row__1BQPY","footer":"styles_footer__23m3w","phraseLength":"styles_phraseLength__3AZ53"};